import { Checkbox } from '@cian/ui-kit';
import classNames from 'classnames';
import { useFormikContext, Field } from 'formik';
import * as React from 'react';

import { IFormValues } from '../DealRentModal';
import * as styles from '../index.css';

export const IsAgent = () => {
  const { values } = useFormikContext<IFormValues>();

  return (
    <div className={classNames(styles['field'], styles['span-columns'])}>
      <Field name="isAgent" as={Checkbox} checked={values.isAgent} label="Я агент, подбираю квартиру для клиента" />
    </div>
  );
};
